import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiHttp } from '@core/api/api-http';
import { ClientOpportunitySummary } from '../models/opportunity';
import { OpportunityApiHttp } from '@core/api/opportunity-api-http';
import { Product } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  constructor(
    private http: OpportunityApiHttp,
  ) {}

  getOpportunities(contactId: string): Observable<ClientOpportunitySummary[]> {
    return this.http
      .get(
        `clients/${contactId}/opportunities`,
        ApiHttp.getStandardOptions()
      )
  }

  getSettledProducts(contactId: string): Observable<Product.Summary[]> {
    return this.http
      .get<Product.SummaryContract[]>(
        `clients/${contactId}/settled-products`,
        ApiHttp.getStandardOptions()
      )
      .pipe(map(Product.toSummaryModel));
  }
}
